import React, {useState, useEffect} from "react";
import Section1 from "../components/Section1";
import layoutimg from '../assets/images/main/layout-img.png';
import layoutthumb from '../assets/images/main/layout-tumb.png';
import LayoutsList from "../components/LayoutsList";
import midimage from '../assets/images/main/midimage.webp';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import howitworksbg from '../assets/images/main/howitworks.png';
import starimg from '../assets/images/main/stars-img.png';
import slideezlogo from '../assets/images/slideezlogo.svg';
import leftborder from '../assets/images/leftborder.png';
import rightborder from '../assets/images/rightborder.png';
import videohome from '../assets/video/introvideo.mp4';

const Home = () => {
    const [searchtext, setsearchtext] = useState("");
    const navigate = useNavigate();
    const handlesearchclick = () => {
        navigate('/find-layouts', {
        state: {
            search: searchtext
        }
        });
    }
    const [layoutdata, setlayoutdata] = useState([]);

    const fetchlayouts = async () => {
      let resp = await axios.get(apiUrl + "alllayouts").then((res) => {
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;
          if (prevdata?.length > 0) {
            setlayoutdata(prevdata);
          } else {
            setlayoutdata([]);
          }
        } else {
        }
      });
    };

    useEffect(() => {
          fetchlayouts()
        }, [])

    return (
      <div className="homepage-layout">
        <section>
          <div className="section1main">
            <div className="container">
              <img src={slideezlogo} className="slideezlogo" />
              <p className="section1title">
                <span className="gradient-head">AI-Powered</span> PowerPoint
                Design <br />
                <span className="headeritalicstyle">
                  Turn Content into Slides in Seconds
                </span>
              </p>
              <div className="section1searchdiv">
                {/* <div
                  className="searchicondiv"
                  onClick={() => {
                    handlesearchclick();
                  }}
                >
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="section1icon"
                  />
                </div> */}
                <div className="searchicondivnew">
                  <img src={starimg} className="start-img" />
                  <p>Search</p>
                </div>
                <input
                  value={searchtext}
                  onChange={(t) => {
                    setsearchtext(t.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handlesearchclick();
                    }
                  }}
                  type="text"
                  className="searchinputdiv"
                />
              </div>
              <p className="section1desc">
                Simply select the layout that best fits your story, then upload,
                paste, or type your content. Our AI automatically adapts your
                text to the chosen design, creating slides that look
                professionally crafted and refines your message to sound sharper
                and more impactful; all within seconds.
              </p>
            </div>
          </div>
        </section>
        <section>
          <div className="homesection2bg">
            {/* <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <p className="layout-head">Layouts</p>
                  <p className="layout-subtext">
                    We understand the power of infographics in capturing
                    attention and delivering information effectively. Whether
                    you're looking to educate, inform, or entertain, our skilled
                    team specializes in creating impactful infographics tailored
                    to your business and industry. Better the way you present
                    your content and engage your audience like never
                    before-contact us today to discover how we can design the
                    perfect infographics for you.
                  </p>
                </div>
                <div className="col-md-4">
                  <img src={midimage} className="layout-img" />
                </div>
              </div>
            </div> */}
            {/* <div className="howitworkstitlediv">
              <div className="thinborder"></div>
              <div className="thindotdiv">
                <div className="thindot"></div>
              </div>
              <div className="bordertitlediv">
                <p>How it works</p>
              </div>
              <div className="thindotdiv">
                <div className="thindot thindot1"></div>
              </div>
              <div className="thinborder"></div>
              
            </div> */}
            <div className="howitworksedgeglow"></div>
            <div className="container">
              <div className="howitworkstitlediv">
                <div className="newthinleftborder">
                  <img src={leftborder} className="newleftborder" />
                </div>
                <div className="bordertitlediv">
                  <p>How it works</p>
                </div>
                <div className="newthinrightborder">
                  <img src={rightborder} className="newleftborder" />
                </div>
              </div>
            </div>
            <img src={howitworksbg} className="howitworksimg" />
            <div className="howitworksedgeglow howitworksedgeglow_right"></div>
          </div>
        </section>
        <section>
          <div className="section3bg">
            {/* <div className="howitworkstitlediv">
              <div className="thinborder"></div>
              <div className="thindotdiv">
                <div className="thindot"></div>
              </div>
              <div className="bordertitlediv">
                <p>Browse Layouts</p>
              </div>
              <div className="thindotdiv">
                <div className="thindot thindot1"></div>
              </div>
              <div className="thinborder"></div>
              
            </div> */}
            <div className="container">
              <div className="howitworkstitlediv">
                <div className="newthinleftborder">
                  <img src={leftborder} className="newleftborder" />
                </div>
                <div className="bordertitlediv">
                  <p>Browse Layouts</p>
                </div>
                <div className="newthinrightborder">
                  <img src={rightborder} className="newleftborder" />
                </div>
              </div>
            </div>
            <div className="container">
              {/* <p className="section3-title">
                      Start with our best PowerPoint layouts
                    </p> */}
              {layoutdata?.length > 0 ? (
                <>
                  <div className="row pplayoutsrow">
                    {layoutdata?.map((item, index) => {
                      if (index < 6) {
                        return (
                          <div
                            className="col-12 col-sm-6 col-md-4 mb-4"
                            onClick={() => {
                              navigate(
                                "/customize-layout" +
                                  "/" +
                                  item?.id +
                                  "/" +
                                  item?.slug
                              );
                            }}
                            key={index}
                          >
                            {/* <img src={assetsUrl + "images/" + item?.image} className="layout-tumb" /> */}
                            <img
                              src={assetsUrl + item?.image}
                              className="layout-tumb"
                            />
                          </div>
                        );
                      }
                    })}
                  </div>
                  <div
                    className="showmorebtn"
                    onClick={() => {
                      navigate("/find-layouts");
                    }}
                  >
                    <p>Show More</p>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </section>
        <section>
          <div className="homesection2bg">
            <div className="container">
              <p className="section3-title">
                A quick way to create a<br /> powerful PowerPoint presentations
              </p>
              <p className="layout-subtext section3-subtitle">
                Create captivating, informative content for PowerPoint in just a
                few
                <br /> minutes—no graphic design experience needed. Here's how:
              </p>
              <div className="videobox">
                <video controls width="100%" loop className="video-home">
                  <source src={videohome} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>

              {/* <div className="videobox">
                <p>Video Tutorial to come here</p>
              </div> */}
            </div>
          </div>
        </section>
      </div>
    );
}

export default Home